module.exports = __webpack_public_path__ + "img/home2.02072328.png";